import { Box, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { getStripePaymentList } from '../../../utils/stripeUtility';

const useStyles = makeStyles((theme) => ({
  defaultPaymentCardLabel: {
    fontFamily: 'TitilliumWeb-Regular',
    fontSize: '17px',
    letterSpacing: '.2px',
    WebkitFontSmoothing: 'auto',
  },
  nameOncardLabel: {
    fontFamily: 'Formula1-Bold',
    fontWeight: 700,
    fontSize: '18px',
    [theme.breakpoints.between('xs', 'md')]: {
      lineHeight: 1.43,
    },
  },
  paymentMethodListItemChangeButtonClicked: {
    paddingLeft: '0 !important',
  },
  imageContainer: {
    lineHeight: 0,
    paddingRight: '15px',
    [theme.breakpoints.between('xs', 'md')]: {
      lineHeight: 1.43,
    },
  },
}));

const PaymentMethodListTemplate = ({
  classes,
  cardTypeIcon,
  isChangeClicked,
  paymentMethodNode,
  isStripeAccount,
}) => {
  const paymentMethodListClasses = useStyles();
  const stripeNameOnCard =
    isStripeAccount && getStripePaymentList(paymentMethodNode)?.nameOnCard;
  return (
    <Box className={classes.paymentNode}>
      <Box className={classes.innerNode}>
        <Box
          className={`${paymentMethodListClasses.imageContainer} ${
            isChangeClicked
              ? paymentMethodListClasses.paymentMethodListItemChangeButtonClicked
              : ''
          }`}
        >
          <img src={cardTypeIcon} alt="" />
        </Box>
        <Box
          className={`${classes.wcNode} ${
            isChangeClicked
              ? paymentMethodListClasses.paymentMethodListItemChangeButtonClicked
              : ''
          }`}
        >
          {isStripeAccount ? (
            <Typography className={paymentMethodListClasses.nameOncardLabel}>
              {stripeNameOnCard}
            </Typography>
          ) : (
            <Typography className={paymentMethodListClasses.nameOncardLabel}>
              {paymentMethodNode?.NameOnCard}
            </Typography>
          )}
        </Box>
      </Box>
      <Grid
        className={`${classes.outerNode} ${
          isChangeClicked
            ? paymentMethodListClasses.paymentMethodListItemChangeButtonClicked
            : ''
        }`}
        item
      >
        <Grid className={classes.accountNumber} item>
          <Typography
            variant="body1"
            style={{
              fontFamily: 'titillium-semibold',
              fontWeight: 700,
              WebkitFontSmoothing: 'auto',
            }}
          >
            {paymentMethodNode?.AccountNumber}
          </Typography>
        </Grid>
        <Grid className={classes.expirationDate} item>
          <Typography
            variant="body1"
            style={{
              fontFamily: 'titillium-semibold',
              fontWeight: 700,
              paddingLeft: '15px',
              WebkitFontSmoothing: 'auto',
            }}
          >
            {`${paymentMethodNode?.ExpirationMonth || '--'}/${
              paymentMethodNode?.ExpirationYear?.slice(-2) || '--'
            }`}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PaymentMethodListTemplate;
